
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { usePolicyTypes } from "@/hooks/usePolicyTypes";
import { usePolicyLines } from "@/hooks/usePolicyLines";
import { PolicyTypeSelectProps } from "./types/select";

export const PolicyTypeSelect = ({ value, onChange, policyLine }: PolicyTypeSelectProps) => {
  const { data: policyTypes } = usePolicyTypes();
  const { data: policyLines } = usePolicyLines();

  if (!policyLines || !policyTypes) {
    return null;
  }

  const selectedPolicyLine = policyLines.find(
    (line) => line.name === policyLine
  );

  const filteredPolicyTypes = policyTypes.filter(
    (type) => type.policy_line_id === selectedPolicyLine?.id
  );

  if (!policyLine || policyLine.trim() === '') {
    return (
      <div className="space-y-2">
        <Label>Policy Type</Label>
        <Select disabled>
          <SelectTrigger className="h-14">
            <SelectValue placeholder="Select a policy line first" />
          </SelectTrigger>
        </Select>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <Label>Policy Type</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-full text-left h-14">
          <SelectValue placeholder="Select policy type" />
        </SelectTrigger>
        <SelectContent>
          {filteredPolicyTypes.map((type) => (
            <SelectItem key={type.id} value={type.name}>
              {type.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
